module.exports = __webpack_public_path__ + "static/kartchen-ortsanbindung2-073984d8ab926c6e1aaa9fdd1de2ed57.png";